export const createZeroArray = (length) => {
    let arrayOfZeros = []
    for(let i = 0; i < length; i++){
        arrayOfZeros.push(0)
    }
    return arrayOfZeros
}